<template>
  <photo-provider>
    <photo-consumer v-for="src in images" :intro="src" :key="src" :src="src">
      <ImageBackground v-on:image-width="passWidth" :src="src" />
    </photo-consumer>
  </photo-provider>
</template>

<script>
import ImageBackground from "@/components/conversations/parts/ImageBackground";

export default {
  name: 'ImageView',
  emits: ['image-width'],
  components: {
    ImageBackground,
  },
  props: ['url'],
  computed: {
    images() {
      return [this.url];
    },
  },
  methods: {
    passWidth(width) {
      this.$emit('image-width', width);
    },
  },
}
</script>
